import React from 'react';
import PropTypes from 'prop-types';
import { ModalProvider, ModalControl } from '@paygreen/paygreen-ui';
import IconByName from '../../utils/IconByName';

/**
 * @description - icon to display a modal with children
 */
const EditModalIcon = ({ title, children, icon, iconSize }) => (
    <ModalProvider>
        <ModalControl hasOnClickControl={true}>
            <IconByName
                name={icon}
                marginLeft="sm"
                hasBackground={true}
                hasHover={true}
                htmlTag="button"
                colorTheme="secondary"
                title={title}
                iconSize={iconSize}
            />
        </ModalControl>

        <ModalControl>{children}</ModalControl>
    </ModalProvider>
);

EditModalIcon.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    icon: PropTypes.string,
    iconSize: PropTypes.string
};

EditModalIcon.defaultProps = {
    icon: "PenIcon",
    iconSize: "xs"
};

export default EditModalIcon;
